
//
// utils
//

import {Promise} from 'es6-promise-polyfill';
import {React, joinUrl, ajax, upload, _n, evalExpr, getCurrentLocaleUrl} from 'pexui';
import globals from '../models/globals';
import {flow} from '../models/flow';
import {isObject} from 'lodash';

exports.Promise = Promise;
exports.evalExpr = evalExpr;

export function resetGlobals(){
    for(let k in globals){
        if(globals.hasOwnProperty(k)){
            delete globals[k];
        }
    }

    globals.config = {};
    globals.widgetConfig = null;
    globals.req = null;
    globals.widgetCallback = null;
}

/**
 * Ajax call
 * @param {object} args
 *    {
 *         url  : the service url
 *         method: HTTP method "GET", "POST" etc
 *         headers: request headers
 *    }
 * @return {object} Promise
 */
export function ajaxPromise(args){
    return new Promise((resolve,reject)=>{
        args.success = (payload, respHeaders) => {
            resolve({
                data: payload,
                headers: respHeaders
            });
        };
        args.error = reject;
        ajax(args);
    });
}

/**
 * Upload a file
 * @param {object} args
 *    {
 *         url  : the service url
 *         file : the file to upload,
 *         formFields:  form fields,
 *         headers: request headers
 *    }
 * @return {object} Promise
 */
export function uploadPromise(args){
    return new Promise((resolve,reject)=>{
        args.success = (file, payload, respHeaders)=>{
            resolve({
                file: file,
                data: payload,
                headers: respHeaders
            });
        };

        args.error = reject;

        upload(args);
    });
}

export function getBaseUri() {
    if(globals.BASE_URI){
        return globals.BASE_URI;
    }

    const widgetConfig = globals.widgetConfig;
    if(widgetConfig && widgetConfig.widget_base_url){
        globals.BASE_URI = widgetConfig.widget_base_url;
        return globals.BASE_URI;
    }

    globals.BASE_URI = findScriptTag('pex_getinfo_widget.js');
    if(globals.BASE_URI){
        return globals.BASE_URI;
    }else{
        throw new Error('Can not find the widget base URL, please either pass widget_config.widget_base_url or define a <script> tag refering the widget js.');
    }
}

export function getSameDomainBaseUrl(){
    let pageUrl = document.location.href;
    pageUrl = pageUrl.replace(/\?.*$/,'');

    let uri = getBaseUri();
    if(pageUrl.indexOf('americanexpress.com') >= 0
      && uri.indexOf('americanexpress.com') === -1){
        // replace E1 URL with E2 URL, download html from E2 instead.
        uri = uri.replace('dxp-docupload-dev.aexp.com', 'dxp-docupload-qa.americanexpress.com');
    }
    return uri;
}


function findScriptTag(scriptName){
    var scripts = document.getElementsByTagName("script");
    for(var i=0;i<scripts.length;i++){
        var script = scripts[i];
        var pos;
        if(script.src && (pos = script.src.indexOf(scriptName)) !== -1){
            var url = script.src.substring(0, pos);
            return url.replace(/\/scripts\/$/, '/');
        }
    }
    return '';
}

export function getElement(elemOrId){
    if(!elemOrId){
        throw new Error("Empty elem id");
    }else if( typeof(elemOrId) === 'string'){
        if(beginsWith(elemOrId,'#')){
            elemOrId = elemOrId.substring(1);
        }

        return document.getElementById(elemOrId);
    }else if(elemOrId instanceof HTMLElement){
        return elemOrId;
    }else if(elemOrId instanceof React.Component){
        return ReactDOM.findDOMNode(elemOrId);
    }
    throw new Error("Invalid element " + elemOrId);
}

export function findElement(query){
    return document.querySelector(query);
}

export function findElements(query){
    var elems = [];
    var list = document.querySelectorAll(query);
    for(var i=0;i<list.length;i++){
        elems.push(list.item(i));
    }
    return elems;
}

export function hasClass(elem, cls){
    return (' ' + elem.className + ' ').indexOf(' ' + cls + ' ') >= 0;
}

export function inArray(arr,obj) {
    if(arr){
        return (arr.indexOf(obj) !== -1);
    }else{
        return false;
    }
}

function arrayAdd(arr, item){
    if(!inArray(arr, item)){
        arr.push(item);
    }
}

export function mergeArray(arr1, arr2){
    arr1 = arr1 || [];
    if(!Array.isArray(arr1)){
        arr1 = [arr1];
    }
    if(arr2){
        if(Array.isArray(arr2)) {
            for (var i = 0; i < arr2.length; i++) {
                arrayAdd(arr1, arr2[i]);
            }
        }else{
            arrayAdd(arr1, arr2);
        }
    }
    return arr1;
}

export function findArray(arr, condition){
    if(arr && Array.isArray(arr)){
        for(var i=0;i<arr.length;i++){
            if(arr[i] && condition(arr[i])){
                return arr[i];
            }
        }
    }
    return null;
}

export function deleteArray(arr, condition){
    if(!(arr && Array.isArray(arr))){
        return arr;
    }
    var done = false;
    while(!done){
        done = true;
        for(var i=0;i<arr.length;i++){
            if(arr[i] && condition(arr[i])){
                arr.splice(i, 1);
                done = false;
                break;
            }
        }
    }
    return arr;
}

export function reduceArray(arr, reducer, initValue){
    if(arr && typeof Array.prototype.reduce === 'function'){
        return arr.reduce(reducer, initValue);
    }else{
        var value = initValue;
        if(arr && Array.isArray(arr)){
            for(var i=0;i<arr.length;i++){
                value = reducer(value, arr[i]);
            }
        }
        return value;
    }
}

export function randomString(len){
    var CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz012345679';
    var s = '';
    for(var i=0;i<len;i++){
        s = s + CHARS.charAt(Math.round(CHARS.length * Math.random()) % CHARS.length);
    }
    return s;
}

export function getAllWeneedCodes (weneedCodes) {
    return weneedCodes.replace(/[\(\)\s]/g, '').replace(/[\|\&|\+]/g, ',');
}

function parseOr(expr){
    var lastPos = -1, level=0;
    var items = [];
    var item = '';
    for(var i=0;i<expr.length;i++){
        var c = expr.charAt(i);
        if(c === '('){
            ++level;
        }else if(c === ')'){
            --level;
            if(level < 0){
                throw new Error("Invalid we need code expression \"" + expr + "\", unpaired braces");
            }
        }else if(level === 0 && c === '|'){
            item = expr.substring(lastPos+1, i);
            lastPos = i;
            items.push(item);
            item = '';
        }
        item += c;
    }
    if(lastPos + 1 < expr.length){
        var item2 = expr.substring(lastPos+1);
        items.push(item2);
    }
    if(items.length > 1){
        var data = [];
        items.forEach(item3=>{
            data.push(parseOr(item3));
        });
        return {
            op: 'OR',
            data: data
        };
    }else{
        return parseAnd(expr);
    }
}

function parseAnd(expr){
    if(expr.length === 0){
        throw new Error("Invalid we need code expression, empty item");
    }

    var lastPos = -1, level=0;
    var items = [];
    var item = '';
    for(var i=0;i<expr.length;i++){
        var c = expr.charAt(i);
        if(c === '('){
            ++level;
        }else if(c === ')'){
            --level;
            if(level < 0){
                throw new Error("Invalid we need code expression \"" + expr + "\", unpaired braces");
            }
        }else if(level === 0 && c === '&'){
            item = expr.substring(lastPos+1, i);
            lastPos = i;
            items.push(item);
            item = '';
        }
        item += c;
    }
    if(lastPos + 1 < expr.length){
        item = expr.substring(lastPos+1);
        items.push(item);
    }
    if(items.length > 1){
        var data = [];
        items.forEach(item=>{
            data.push(parseAnd(item));
        });
        return {
            op: 'AND',
            data: data
        };
    }else{
        if(expr.charAt(0) === '('){
            if(expr.charAt(expr.length - 1) === ')'){
                return parseOr(expr.substring(1, expr.length - 1));
            }else{
                throw new Error("Invalid we need code expression \"" + expr + "\", unpaired braces");
            }
        }else{
            return {
                op: 'ITEM',
                data: expr
            };
        }
    }
}

export function parseWeneedCodes (weneedCodes) {
    weneedCodes = weneedCodes.replace(/[\s]/g, '').replace(/[\+,]/g, '&');
    return parseOr(weneedCodes);
}

export function goOverFlowNodes(nodes, handler){
    if(nodes){
        nodes.forEach(node=>{
            handler(node);
            if(node.choices){
                node.choices.forEach(choice=>{
                    goOverFlowNodes(choice, handler);
                });
            }
        });
    }
}

export function goOverTree (node, f) {
    if(node.op === 'OR'){
        f('(');
        for(let i=0;i<node.data.length;i++){
            if(i > 0){
                f('OR');
            }
            goOverTree(node.data[i], f);
        }
        f(')');
    }else if(node.op === 'AND'){
        f('(');
        for(let i=0;i<node.data.length;i++){
            if(i > 0){
                f('AND');
            }
            goOverTree(node.data[i], f);
        }
        f(')');
    }else if(node.op === 'ITEM'){
        f(node);
    }
}

export function registerMessageHandler(handler){
    // Create IE + others compatible event handler
    var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
    var eventer = window[eventMethod];
    var messageEvent = eventMethod === "attachEvent" ? "onmessage" : "message";

    // Listen to message from child window
    eventer(messageEvent,handler,false);
}

export function isHtml(text){
    return /<\w{1,5}.*>/.test(text);
}

export function isContentId(str){
    return typeof str === 'string' && /^[\w_]([\w_\-\.]*[\w_])?$/.test(str);
}

export function getUrlFromResource(contentId){
    var url = isContentId(contentId) ? _n(contentId) : contentId;
    if(typeof url === 'string' && url){
        url = url.replace(/^\s*url\((.*)\)\s*$/, '$1');
        url = url.trim();

        if(/^https?:\/\//i.test(url)){
            // absolute url
        }else{
            // relative url
            url = makeUrl(getCurrentLocaleUrl(), url);
        }
    }
    return url;
}

export function formatHtml(text){
    // rich text
    if(isHtml(text)){
        text = safeHtml(text);
    }else if(text.indexOf('\n') >= 0){
        text = text.replace(/\n/g, '<br/>');
    }
    return text;
}

export function safeHtml(html){
    if(html){
        // remove comments
        html = html.replace(/<!--[\s\S]*?-->/g, '');
        var m = /<\s*body[^\>]*>([\s\S]*)<\/\s*body\s*>/i.exec(html);
        if(m){
            // only the body content
            html = m[1];
        }
        // removes script tags for injection attack
        html = html.replace(/<\s*script[^>]*>[\s\S]*?<\/\s*script\s*>/gi, '');
        // make all hyperlinks shown in new tabs, in order not to break the widget.
        html = html.replace(/<a\s+([^>]*)>/gi, (tag, attrs)=>{
            if(/target\s*=/i.test(attrs)){
                return tag;
            }else{
                return '<a ' + attrs + ' target="_blank">';
            }
        });
        html = html.replace(/<\w+[^>]*>/g, (tag)=>{
            // removes event handlers
            return tag.replace(/\son\w+\s*=\s*\"[^\"]*\"/gi, '');
        });
    }
    return html;
}

/**
 * Get HTML or plain text content by contentId
 * @param {String} contentId
 * @return {object} could be a String if the content is ready, or a promise
 */
export function getHtmlContent(contentId, value){
    let content = getContent(contentId, value);
    if(content instanceof Promise){
        return content.then(resp=>{
            resp.data = safeHtml(resp.data);
            return resp;
        });
    }else{
        return safeHtml(content);
    }
}


export function getHtml(content){
    if(isContentId(content)){
        // like a content id
        content = getHtmlContent(content);
    }else{
        content = formatHtml(content);
    }

    if(typeof content === 'string'){
        // a string
        if(isHtml(content)){
            const elem = document.createElement('span');
            elem.innerHTML = content;
            return elem;
        }else{
            return content;
        }
    }else if(content instanceof Promise){
        // a promise
        const elem = document.createElement('span');
        content.then(resp=>{
            elem.innerHTML = resp.data;
        })
        return elem;
    }else{
        return content;
    }
}

/**
 * Get HTML or plain text content by contentId
 * @param {String} contentId
 * @return {object} could be a String if the content is ready, or a promise
 */
export function getContent(contentId, value){
    let content = isContentId(contentId) ? _n(contentId, value): evalExpr(contentId, value);
    const m = /^\s*url\((.*)\)\s*$/.exec(content);
    if(m){
        // url
        let url = m[1].trim();

        if(/^https?:\/\//i.test(url)){
            // absolute url
        }else{
            // relative url
            url = makeUrl(getCurrentLocaleUrl(), url);
        }

        if(globals.htmlCache && globals.htmlCache.hasOwnProperty(url)){
            return evalExpr(globals.htmlCache[url], value);
        }else{
            return ajaxPromise({
                method: 'GET',
                url: url
            }).then(resp=>{
                var content = resp.data;

                // cache it
                if(!globals.htmlCache){
                    globals.htmlCache = {};
                }
                globals.htmlCache[url] = content;

                resp.data =  evalExpr(content, value);
                return resp;
            }).catch(err=>{
                logError(err);
            });
        }
    }else{
        return content;
    }
}

export function makeUrl(url, path){
    url = url.replace('\?.*$','').replace(/[^\/]+$/,'');
    path = path.replace(/^(\.\/)+/, '');
    while(/^\.\.\//.test(path)){
        // deletes starting ../
        path = path.replace(/^\.\.\/(\.\/)*/, '');
        // deletes ending foo/
        url = url.replace(/[^\/]+\/?$/, '');
    }
    url = url + path;
    return url;
}

export function parseYodleeResponse(encoded){
    var decoded = encoded.replace(/\%([0-9a-fA-F]{2})/g, (_all, hex)=>(
        String.fromCharCode(parseInt(hex, 16))
    ));
    var o = {};
    decoded.split('&').forEach(phrase=>{
        var pos = phrase.indexOf('=');
        if(pos > 0){
            var key = phrase.substring(0, pos);
            var value = phrase.substring(pos+1);
            o[key] = value;
        }
    });
    return o;
}

export const formatYodleeData = data => {
    if (isObject(data)) {
        return JSON.stringify(data).slice(1, -1);
    }
    return data;
};

export function parseUrlParams(urlQuery){
    urlQuery = urlQuery || '';
    var o = {};
    urlQuery.split('&').forEach(phrase=>{
        var pos = phrase.indexOf('=');
        if(pos > 0){
            var key = phrase.substring(0, pos);
            var value = phrase.substring(pos+1).replace(/\+/g, ' ').replace(/\%([0-9a-fA-F]{2})/g, (_all, hex)=>(
                String.fromCharCode(parseInt(hex, 16))
            ));;
            o[key] = value;
        }
    });
    return o;
}

export const determineMessageType = data => {
    if (/JSONCallbackStatus/.test(data)) {
        return 'JSONCallbackStatus';
    } else if (/yodlee_success/.test(data)) {
        return 'yodlee_success';
    } else if (/yodlee_login_error/.test(data)) {
        return 'yodlee_login_error';
    } else if (/yodlee_login_error/.test(data)) {
        return 'yodlee_login_error';
    } else if (/yodlee_session_error/.test(data)) {
        return 'yodlee_session_error';
    } else if (/yodlee_tech_error/.test(data)) {
        return 'yodlee_tech_error';
    } else if (/yodlee_default_error/.test(data)) {
        return 'yodlee_default_error';
    }
};

export function filenameMatches(fname1, fname2){
    fname1 = fname1.replace(/^.*\//, '');
    fname2 = fname2.replace(/^.*\//, '');
    return fname1.toLowerCase() === fname2.toLowerCase();
}

const monthNames = [
    "Jan", "Feb", "Mar",
    "Apr", "May", "Jun", "Jul",
    "Aug", "Sep", "Oct",
    "Nov", "Dec"
   ];

function getDaySuffix(day){
    if(day < 10 || day > 20){
        switch(day % 10){
        case 1:
            return 'st';
        case 2:
            return 'nd';
        case 3:
            return 'rd';
        default:
            break;
        }
    }
    return 'th';
}

export function formatTime(d){
    return monthNames[d.getMonth()] + ' ' + d.getDate() + getDaySuffix(d.getDate()) + ',' + d.getFullYear();
}

export function beginsWith(s1, s2){
    return s1.lastIndexOf(s2, 0) === 0;
}

export function endsWith(s1, s2){
    return s1.length >= s2.length
        && s1.lastIndexOf(s2, s1.length - s2.length) === s1.length - s2.length;
}

export function sprintf() {
    const args = arguments,
        fmt = args[0];
    let argsIdx = 1;
    return fmt.replace(/%(%|\d*s|\d*d|\d*(\.\d*)?f)/g, function (m) {
        // m is the matched format, e.g. %s, %d
        let val;
        if (m === '%%') {
            val = '%';
        } else if(endsWith(m, 's')){
            val = sprintf4s(m, String(args[argsIdx++]));
        } else if(endsWith(m, 'd')){
            val = sprintf4d(m, String(args[argsIdx++]));
        } else if(endsWith(m, 'f')){
            val = sprintf4f(m, args[argsIdx++]);
        } else {
            throw new Error("Won't happen, format:[" + m + "]");
        }
        return val;
    });
}

function sprintf4s(fmt, val){
    const m = /%(\d*)s/.exec(fmt);
    if(m && m[1]){
        const digFmt = m[1];
        const fillChar = ' ';
        const len = parseInt(digFmt);
        while(val.length < len){
            val = fillChar + val;
        }
    }
    return val;
}

function sprintf4d(fmt, val){
    const m = /%(\d*)d/.exec(fmt);
    if(m && m[1]){
        const digFmt = m[1];
        const fillChar = digFmt[0] === '0'? '0': ' ';
        const len = parseInt(digFmt);
        while(val.length < len){
            val = fillChar + val;
        }
    }
    return val;
}

function sprintf4f(fmt, val){
    const m = /%(\d*)(?:\.(\d*))?f/.exec(fmt);
    if(m){
        if(typeof val==='string'){
            val = parseFloat(val);
        }
        if(m[2]){
            const dec = parseInt(m[2]);
            val = val.toFixed(dec);
        }
        val = String(val);
        if(m[1]){
            const len = parseInt(m[1]);
            while(len > 0 && val.length < len){
                val = ' ' + val;
            }
        }
    }
    return val;
}

export function getTimestamp(){
    var now = new Date();
    return formatTimestamp(now);
}

export function formatTimestamp(now){
    return sprintf("%02d/%02d/%04d %02d:%02d:%02d.%04d", now.getUTCMonth()+1, now.getUTCDate(), now.getUTCFullYear(),
        now.getUTCHours(), now.getUTCMinutes(), now.getUTCSeconds(), now.getUTCMilliseconds());
}

export function getUniqueId(prefix, node){
    return prefix + '_' + ((node && node.widgetOption) ? node.widgetOption.content_id: randomString(5));
}

/**
 * Converts a response object to error message
 * @param {object} respObj
 * @return {string} error message
 */
export function convertError(respObj){
    if(respObj){
        if(respObj instanceof Error){
            respObj = respObj.message;
            if(respObj.charAt(0) === '!'){
                // already converted
                return respObj.substr(1);
            }
        }

        if(typeof respObj === 'object' && respObj.response_code){
            logError('Error code:' + respObj.response_code + ', message: ' + respObj.response_message);
            flow.lastError = respObj.response_code;
            return {
              message: _n('error.' + respObj.response_code + '.message'),
              errorKey: 'error.' + respObj.response_code + '.message'
            };
        }else if(typeof respObj === 'string'){
            logError('Error:' + respObj);
            if(respObj.charAt(0) === '!'){
                // already converted
                return { message: respObj.substr(1) };
            }
            const m = /code:\s*(\d+)/i.exec(respObj);
            if(m){
                const errMessage = _n('error.' + m[1] + '.message');
                if(errMessage){
                    return {
                      message: errMessage,
                      errorKey: 'error.' + m[1] + '.message'
                    };
                }
            }

            return {
              message: _n('error.service.message'),
              errorKey: 'error.service.message'
            };
        }
    }
    return {
      message: _n('error.default.message'),
      errorKey: 'error.default.message'
    };
}

export function logError(err){
    console.error(err);
}

export function getLanguage(locale){
    if(locale && typeof locale === 'string'){
        var m = /^[a-z]{2}/.exec(locale);
        if(m){
            return m[0];
        }else{
            return 'en'; // default language
        }
    }else{
        return 'en';
    }
}

export function isGoodBrowser() {
    const userAgent = window.navigator.userAgent;
    return userAgent.indexOf('Chrome') >= 0
        || userAgent.indexOf('Firefox') >= 0
        || userAgent.indexOf('Safari') >= 0;
}



// WEBPACK FOOTER //
// ./application/src/utilities/utils.js